import { MoreOutlined } from '@ant-design/icons';
import useExport from '@components/export/useExport';
import { Dropdown, Space } from 'antd';
import React from 'react';

export const usageExportConfig = {
  page: { key: 'usageDashboard', title: 'Usage Dashboard' },
  sections: [
    { key: 'ud-summary', title: '' },
    { key: 'ud-video-metric-timeseries' },
    { key: 'ud-app-metric-timeseries' },
  ],
};

export const Kebab = () => {
  const { triggerDownload } = useExport({ config: usageExportConfig });

  const kebabItems = [
    {
      key: '1',
      label: <a onClick={triggerDownload}>Export</a>,
    },
  ];

  return (
    <Dropdown menu={{ items: kebabItems }} trigger={['click']}>
      <Space style={{ lineHeight: 2, fontSize: 18, cursor: 'pointer' }}>
        <MoreOutlined />
      </Space>
    </Dropdown>
  );
};
